import React from 'react';
import { Route } from 'react-router';
import AnnouncementManagement from './screens/AnnouncementManagement/router';
import DepartmentAnnouncement from './screens/DepartmentAnnouncement/router';
export default (
  <Route
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
    {AnnouncementManagement}
    {DepartmentAnnouncement}
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/DepartmentNews/router.js
 **/